import React, { useEffect } from "react";

import ToggleSwitch from "../../../../../CommonComponents/ToggleSwitch/ToggleSwitch";

import { BRAND_ICONS_URLS, PERSONAL_LIMITS } from "../../../../../../utils/Constants";
import moneyFormatter from "../../../../../../utils/MoneyFormatter";
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import { AppStrings } from "../../../../../../utils/constants/AppStrings";

function PersonalLimits({
  userPersonalLimit,
  setTitle,
  setIsViewPersonalLimitsPopupVisible,
  setIsEditTimeLimitsPopupVisible,
  setIsEditCurrencyLimitsPopupVisible,
  getUserPersonalLimit,
  isApiRunning,
  setEditingMode,
}) {
  const handleEditClick = (section) => {
    setEditingMode(true);
    switch (section) {
      case PERSONAL_LIMITS.TIME_LIMITS:
        setTitle(AppStrings.EDIT_TIME_LIMITS);
        setIsViewPersonalLimitsPopupVisible(false);
        setIsEditTimeLimitsPopupVisible(true);
        break;
      case PERSONAL_LIMITS.CURRENCY_LIMITS:
        setTitle(AppStrings.EDIT_CURRENCY_LIMITS);
        setIsViewPersonalLimitsPopupVisible(false);
        setIsEditCurrencyLimitsPopupVisible(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getUserPersonalLimit(false);
  }, []);

  return (
    <div className="personal-limits-body">
      {isApiRunning ? (
        <RebetLoader />
      ) : (
        <>
          <div className="personal-limits-section-container">
            <div className="personal-limits-section-header">
              {AppStrings.TIME_LIMITS}
              <span
                className="personal-limits-edit-button"
                onClick={() => handleEditClick(PERSONAL_LIMITS.TIME_LIMITS)}
              >
                {AppStrings.EDIT}
              </span>
            </div>
            <div className="personal-limits-section-body">
              <div className="personal-limits-section-item border-bottom">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_NUMBERS_OF_DAYS_YOU_PLAY_THE_GAMES_PER_WEEK}
                  </div>
                  <div className="personal-limits-section-item-value">
                    {userPersonalLimit.max_playing_time_per_week !== false
                      ? `${userPersonalLimit.max_playing_time_per_week} days`
                      : "-"}
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_playing_time_per_week}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
              <div className="personal-limits-section-item">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_TIME_YOU_SPEND_PLAYING_PER_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    {userPersonalLimit.max_playing_time_per_day !== false
                      ? `${userPersonalLimit.max_playing_time_per_day} hours`
                      : "-"}
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_playing_time_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
            </div>
          </div>
          <div className="personal-limits-section-container">
            <div className="personal-limits-section-header">
              {AppStrings.CURRENCY_LIMITS}
              <span
                className="personal-limits-edit-button"
                onClick={() => handleEditClick(PERSONAL_LIMITS.CURRENCY_LIMITS)}
              >
                {AppStrings.EDIT}
              </span>
            </div>
            <div className="personal-limits-section-body">
              <div className="personal-limits-section-item border-bottom">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_PURCHASE_AMOUNT_OF_SECONDARY_CURRENCY_PER_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                      src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.secondaryCurrencySymbol}
                      alt="Coin Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                      {userPersonalLimit.max_coin_purchase_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_coin_purchase_per_day
                        )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_coin_purchase_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
              <div className="personal-limits-section-item">
                <div>
                  <div className="personal-limits-section-item-label">
                    {AppStrings.MAX_PRIMARY_CURRENCY_BONUS_PER_DAY}
                  </div>
                  <div className="personal-limits-section-item-value">
                    <img
                      src={process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL + BRAND_ICONS_URLS.primaryCurrencySymbol}
                      alt="Cash Icon"
                      width={15}
                      height={15}
                    />
                    <span>
                      {userPersonalLimit.max_cash_bonus_per_day !== false
                        ? moneyFormatter(
                          userPersonalLimit.max_cash_bonus_per_day
                        )
                        : "-"}
                    </span>
                  </div>
                </div>
                <ToggleSwitch
                  status={userPersonalLimit.max_cash_bonus_per_day}
                  eventCode={"123"}
                  updateEventCode={() => { }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PersonalLimits;
